<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10Fb89g/images/cover.jpg?1684515201228" alt="This image is the cover for the book Refresh"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Refresh
      </h1>
      <p class="bookDescription body article font2">
        <p>More than one-fifth of US households with children have at least one child with special needs. Raising a child with special needs is spiritually, emotionally, mentally, and physically challenging. Parents of these children have higher rates of depression, anxiety, and divorce. They need encouragement to restore hope and a passion for God in their lives—-but the realities of having to be parent, nurse, therapist, and caregiver make it difficult to find the time or initiative to seek encouragement.<br/><br/>Written by two moms who understand this complicated balancing act, <i>Refresh</i> is designed to provide just what these parents need. The 90-day devotional guides parents to spiritual truths that can be applied to the demands they face every day. It offers perspective and hope through the varying stages and phases families experience, from diagnosis to loss and grief.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kimberly M. Drew
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Kregel
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?486f76f8